import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { loadPinMapsReset } from 'services/redux/actions/serviceDesk';
import conxtdOut from 'apis/conxtdOut';
import Alert from 'components/Common/Alert';

import cslPinWarningLight from '../../images/csl-pro-pin-profile-light.png';
import cslPinWarningDark from '../../images/csl-pro-pin-profile-dark.png';

export function useSiteDetailsHandler() {
  const darkMode = useSelector((state) => state.app.darkMode);
  const dispatch = useDispatch();

  const resetPinMapData = useCallback(() => {
    dispatch(loadPinMapsReset());
  }, [dispatch]);

  /**
   * Handler function that runs the alert & submission logic for - Site Details
   */
  const handleSiteDetails = useCallback(async ({
    pinMapsData,
    sudoSiteId,
    editData,
    selectedOption,
    setLoadingSubmitEdit,
    checkCSLChange,
    setCheckCSLChange,
    enterprise_id,
    setEditMode,
    companyId,
    getSiteDetails,
    updateUrlSiteRef,
  }) => {

    const existingPins = () => {
      const sudoPins = pinMapsData?.sudo_pins ?? {};
      const fastFormats = pinMapsData?.fast_formats ?? {};

      return (
        Object.values(sudoPins)?.length > 0 
      ||
        Object.values(fastFormats)?.length > 0
      );
    }

    const generateDynamicMessage = () => {
      const defaultMessage = '<p>Are you sure you want to save these changes?</p>';
      const pinsWarningMessage = `<hr /><p>Note: Existing pins will be deleted and replaced with the CSL Pro pins template displayed below</p>`;
      const newPinsWarningMessage = `<hr /><p>Note: This change will add a CSL Pro pins template as displayed below</p>`;

      if (checkCSLChange) {
        return `
          <div>
            <span>${defaultMessage}${existingPins() ? pinsWarningMessage : newPinsWarningMessage}</span>
            <img src="${darkMode ? cslPinWarningDark : cslPinWarningLight}" 
                 alt="CSL Pro pin profile" 
                 class="img-fluid" />
          </div>
        `;
      }
      return `<div>${defaultMessage}</div>`;
    };

    const result = await Alert({
      html: generateDynamicMessage(),
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Confirm',
      cancelButtonText: 'Cancel',
    });

    if (!result.value) return;

    if (selectedOption === 'Site Details' && sudoSiteId && companyId) {
      try {
        setLoadingSubmitEdit(true);
        await conxtdOut.post(`/ServiceDesk/editSiteDetails/${sudoSiteId}/${companyId}`, editData);
        setLoadingSubmitEdit(false);

        Alert({
          text: 'Changes saved successfully',
          icon: 'success',
          timerProgressBar: true,
          timer: 5000,
        });

        setEditMode(false);
        if (companyId) getSiteDetails();
        updateUrlSiteRef();
        resetPinMapData();
        setCheckCSLChange(false);

        if (enterprise_id) {
          window.caching.flush(`LOAD_GROUPS_BACKGROUND_SUCCESS/${enterprise_id}`);
          window.caching.flush(`LOAD_SITES_BACKGROUND_SUCCESS/${enterprise_id}`);
        }

      } catch (error) {
        console.error(error);
        setLoadingSubmitEdit(false);
        Alert({
          text: 'An issue occurred. Please try again later.',
          icon: 'error',
        });
      }
    }
  }, [darkMode, resetPinMapData]);

  return { handleSiteDetails };
}
